// extracted by mini-css-extract-plugin
module.exports = {"home":"home_home__n68vr","main_content":"home_main_content__25OWd","sub_head":"home_sub_head__2MZRe","info":"home_info__gr2fB"};